<template>
  <div class="wraper">
    <el-row class="top">
      <span>商品报表</span>
      <el-tooltip placement="right">
        <div slot="content">
          商品报表：以商品为维度，对商品统一查看管理
        </div>
        <i class="el-icon-question"></i>
      </el-tooltip>
      <el-date-picker
        size="mini"
        v-model="date"
        type="daterange"
        align="right"
        unlink-panels
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :clearable="clearDate"
      >
      </el-date-picker>
      <el-button size="mini" type="primary" @click="search">查询</el-button>
      <div class="export_btn">
        <exporter
          :setting="setting"
          :postParams="postParams"
          :url="getListUrl"
          :date="date"
          :exportName="exportName"
        ></exporter>
      </div>
    </el-row>
    <deviceSearchBox
      :postParams="postParams"
      @getSearchSelect="searchTable"
    ></deviceSearchBox>

    <!-- 柱状图 -->
    <div id="selectdiv">
      <select @change="changeReport">
        <option>销售数据（销售量前10）</option>
        <option>销售数据（销售量后10）</option>
      </select>
    </div>
    <!-- echarts图 -->
    <el-row style="margin-bottom:60px;height:550px">
      <div
        style="display: flex;
    justify-content: space-between;"
      >
        <div class="spanClass">
          <span
            v-for="(item, index) in ['销售数量', '销售金额']"
            @click="indexClick(index, item)"
            :key="index"
            :class="{ active: index == isActive }"
            >{{ item }}</span
          >
        </div>
        <div class="days">
          <span @click="dayClick()">天</span>
          <span class="active" @click="weekClick()">周</span>
          <span @click="mounthClick()">月</span>
        </div>
      </div>
      <div style="width:100%; min-height:550px" id="main"></div>
    </el-row>
    <!-- table 表 -->
    <div class="shouQi" ref="content" @click="showTable()">
      收起明细数据 ^
    </div>
    <el-row v-show="isShow">
      <report
        :setting="setting"
        :list="list"
        :date="date"
        @changeSort="handleSun"
      ></report>
      <el-row class="pages">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import Report from "../../components/Report";
import exporter from "../../components/exporter";
import deviceSearchBox from "../devices/components/deviceSearchBox";
import * as echarts from "echarts";
export default {
  name: "device",
  components: {
    Report,
    exporter,
    deviceSearchBox
  },
  data() {
    return {
      getListUrl: "data/getDataReport_GoodsList",
      date: this.getDefaultDay(),
      clearDate: false,
      active: "active",
      isShow:true,
      reportType:'count',
      topOrAfter:'topten',
      sData:[],
      yData:[],
      isActive: 0,
      exportName: "商品报表",
      postParams: {
        areaCompanyId: "",
        provinceBranchCompanyId: "",
        productModelType: "",
        agencyType: "",
        channelType: "",
        secondChannelType: "",
        thirdChannelType: "",
        dealerCompanyId: "",
        cityCode: "",
        marketType: "",
        provinceCode: "",
        putPolicy: "",
        storeId: "",
        keyWord: ""
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 1000 * 60 * 60 * 24;
        },
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, start]);
            }
          },
          {
            text: "最近七天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      currentPage: 1,
      setting: {
        isShowSelect: false,
        isShowIndex: false,
        tHeader: [
          {
            dataItem: "goodsNum",
            dataName: "商品编码"
          },
          {
            dataItem: "className",
            dataName: "商品分类"
          },
          {
            dataItem: "goodsName",
            dataName: "商品名称"
          },
          {
            dataItem: "price",
            dataName: "单价(元)"
          },
          {
            dataItem: "size",
            dataName: "规格"
          },
          {
            dataItem: "sumSalesNum",
            dataName: "销售数量"
          },
          {
            dataItem: "sumSalesAmount",
            dataName: "销售金额"
          }
        ],
        isShowPlay: true,
        isShowDelBtn: false,
        isShowEditBtn: false,
        isShowInfoBtn: false,
        isShowGoodsRanks: true,
        infoUrl: "goodsRankDetail"
      },
      list: [],
      total: 0,
      pageSize: 10
    };
  },
  mounted() {
    this.getList();
    
  },
  methods: {
    getDefaultDay() {
      let date = new Date();
      let startdate = new Date(date.getTime() - 1000 * 60 * 60 * 24 * 8);
      let startyear = startdate.getFullYear();
      let startmonth = startdate.getMonth() + 1;
      if (startmonth < 10) {
        startmonth = "0" + startmonth;
      }
      let startday = startdate.getDate();
      if (startday < 10) {
        startday = "0" + startday;
      }
      startdate = startyear + "-" + startmonth + "-" + startday;
      let enddate = new Date(date.getTime() - 1000 * 60 * 60 * 24);
      let endyear = enddate.getFullYear();
      let endmonth = enddate.getMonth() + 1;
      if (endmonth < 10) {
        endmonth = "0" + endmonth;
      }
      let endday = enddate.getDate();
      if (endday < 10) {
        endday = "0" + endday;
      }
      enddate = endyear + "-" + endmonth + "-" + endday;
      return [startdate, enddate];
    },
    getList(val) {
      let url = this.getListUrl;
      let paramsObj = this.postParams;
      let params = {
        startDay: this.date[0],
        endDay: this.date[1],
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        reportType:this.reportType,
        topOrAfter:this.topOrAfter
      };
      if (val != undefined) {
        params.order = val.order;
        params.prop = val.prop;
      }
      for (let k in paramsObj) {
        if (paramsObj[k] != "") params[k] = paramsObj[k];
      }
      let _this = this;
      this.$ajax
        .post(url, params)
        .then(this.getListSucc)
        .catch(function(res) {
          _this.$message.error("哎呀~网络异常了呢");
        });
    },
    drawCharts(yData,sData) {
      var chartDom = document.getElementById("main");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },

        grid: {
          left: "20%",
          x2: "1%",
          right: "5%"
        },
        xAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#fff",
              width: 1 //这里是为了突出显示加上的
            }
          }
        },
        yAxis: {
          type: "category",
          data: yData,
          axisLine: {
            lineStyle: {
              color: "#FFFFFF",
              width: 1 //这里是为了突出显示加上的
            }
          }
        },
        series: [
          {
            type: "bar",
            data: sData,
            barMaxWidth: "20%",
            label: {
                show: true,
                position: 'right'
            },
            itemStyle: {
              normal: {
                color: "rgb(253, 213, 151)"
              }
            }
          }
        ]
      };
      option && myChart.setOption(option);
    },
    showTable(){
      this.isShow = !this.isShow;
      if (this.isShow) {
        this.$refs.content.innerHTML = "收起明细数据 ^"
      }else {
        this.$refs.content.innerHTML = "展开明细数据 v"
      }
    },
    // 变换颜色
    indexClick(index, item) {
      this.isActive = index;
      if (item === "销售数量") {
        this.reportType = "count"
      }else {
        this.reportType = "amount"
      }
      this.getList();
    },
    // 更改报表
    changeReport(e){
      console.log(e.target.value);
      if (e.target.value == "销售数据（销售量前10）") {
        this. topOrAfter = "topten"
      }else {
        this. topOrAfter = "afterten"
      }
      this.getList();
    },
    // 其他兄弟节点移除active 类
    siblings(elm) {
      var p = elm.parentNode.children;
      for (var i = 0, pl = p.length; i < pl; i++) {
        if (p[i] !== elm) {
          p[i].classList.remove("active");
        }
      }
    },
    // 转换时间
    timeFormat(time) {
      // 时间格式化 2019-09-08
      let year = time.getFullYear();
      let month =
        time.getMonth() + 1 > 10
          ? time.getMonth() + 1
          : "0" + (time.getMonth() + 1);
      let day = time.getDate() > 10 ? time.getDate() : "0" + time.getDate();
      return year + "-" + month + "-" + day;
    },

    // 选择天
    dayClick() {
      var obj = document.getElementsByClassName("days")[0];
      var nowNode = obj.firstElementChild;
      this.siblings(nowNode);
      nowNode.classList.add("active");
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24);

      this.date = [this.timeFormat(start), this.timeFormat(start)];
      this.search();
    },
    // 选择周
    weekClick() {
      var nowNodes = document
        .getElementsByClassName("days")[0]
        .getElementsByTagName("span");
      this.siblings(nowNodes[1]);
      nowNodes[1].classList.add("active");

      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 8);
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
      this.date = [this.timeFormat(start), this.timeFormat(end)];
      this.search();
    },
    // 选择月
    mounthClick() {
      var nowNodes = document
        .getElementsByClassName("days")[0]
        .getElementsByTagName("span");
      this.siblings(nowNodes[2]);
      nowNodes[2].classList.add("active");
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.date = [this.timeFormat(start), this.timeFormat(end)];
      this.search();
    },
    getListSucc(res) {
      if (res.data && res.data.code === 200) {
        const data = res.data.data;
        this.list = data.tableList.list;
        this.total = data.tableList.total;
        this.sData = data.numberList;
        this.yData = data.nameList;
      
        this.drawCharts(this.yData,this.sData);
      } else {
        let errMsg = "未知错误";
        if (res.data.msg) {
          errMsg = res.data.msg;
        }
        this.$message.error(errMsg);
      }
    },
    search() {
      this.getList();
    },
    handleSizeChange(val) {
      // console.log('每页 '+val+' 条');
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
      // console.log(this.pageSize);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    handleSun(val) {
      this.getList(val);
    },
    searchTable() {
      //console.log(this.postParams)
      this.getList();
    }
  }
};
</script>
<style scoped>
.active {
  background: rgb(251, 170, 123);
  color: #000;
}
.top {
  height: 50px;
}

.pages {
  padding-top: 10px;
  text-align: center;
}
#selectdiv {
  margin-bottom: 10px;
}

#selectdiv select {
  height: 30px;
  background: transparent;
  color: #fff;
  border: none;
  outline: none;
  cursor: pointer;
}
#selectdiv select option {
  background: transparent;
  color: black;
  
}
.spanClass {
  width: 60%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  font-size: 14px;
}
.spanClass span {
  display: inline-block;
  border: 1px solid rgb(251, 170, 123);
  padding: 3px;
  margin-top: 5px;
  margin-right: 5px;
  cursor: pointer;
  flex-shrink: 1;
  padding: 5px 10px;
}
.days span {
  display: inline-block;
  border: 1px solid rgb(251, 170, 123);
  padding: 3px 15px;
  float: left;
  margin-top: 5px;
  cursor: pointer;
}
.shouQi {
  display: inline-block;
  margin-bottom: 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/reports/goodsRep.vue